export const injectCss = (css) => {
    try {
        // TODO add test for css-reset
        const dataAttribute = 'data-test';
        const identifier = String(import.meta.env.VITE_APP_CSS_RESET_CLASS_NAME) || 'css-reset';
        const alreadyInjected = document.querySelector(`[${dataAttribute}="${identifier}"]`);
        if (alreadyInjected) {
            return false;
        }
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.setAttribute(dataAttribute, identifier);
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
        return true;
    }
    catch {
        console.log('Unable to inject CSS reset');
    }
};
//# sourceMappingURL=injectCss.js.map